import script from "./AssistentsShare.vue?vue&type=script&setup=true&lang=js"
export * from "./AssistentsShare.vue?vue&type=script&setup=true&lang=js"

import "./AssistentsShare.vue?vue&type=style&index=0&id=2c608870&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c608870"]])

export default __exports__